import { Capacitor } from "@capacitor/core";
import Keycloak from "keycloak-js";
import React from "react";
import { AuthCapacitorProvider } from "./AuthCapacitorProvider.js";
import { AuthWebProvider } from "./AuthWebProvider.js";

interface Props extends React.PropsWithChildren<{}> {
  keycloak: Keycloak;
}

export const AuthProvider = ({ children, keycloak }: Props) => {
  if (Capacitor.isNativePlatform()) {
    return (
      <AuthCapacitorProvider keycloak={keycloak}>
        {children}
      </AuthCapacitorProvider>
    );
  }

  return <AuthWebProvider keycloak={keycloak}>{children}</AuthWebProvider>;
};
